<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import { debounce } from "@/helpers/debounce";
import { defineAsyncComponent } from "vue";
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";

const DetailRekapInstruktur = defineAsyncComponent(async () => {
  await new Promise((r) => setTimeout(r, 500));
  return import("./detail-rekap_instruktur.vue");
});

export default {
  page: {
    title: "Rekap Instruktur",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Datatable,
    Pagination,
    DetailRekapInstruktur,
  },
  data() {
    let sortOrders = []; // select sortOrder

    // definisi kolom yang dipakai
    let columns = [
      { width: "50px", label: "No", name: "user_id" },
      { width: "auto", label: "NIP", name: "username" },
      { width: "auto", label: "Nama", name: "name" },
      { width: "auto", label: "Unit", name: "unit_name" },
      { width: "auto", label: "Jabatan", name: "jabatan_name" },
      { width: "auto", label: "Email", name: "email" },
      { width: "auto", label: "Nomor HP", name: "mobile_phone" },
      { width: "auto", label: "Total Pembelajaran Selesai", name: "-" },
    ];

    // cek sorting
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      title: "Rekap Instruktur",
      items: [
        {
          text: "Rekap",
          href: "/",
        },
        {
          text: "Data Instruktur",
          active: true,
        },
      ],
      namePathUrl: this.$route.name,
      sessionRoleId: localStorage.session_role_active_id,

      showDetail: false,
      idData: null,

      // variable Page Table
      loadingTable: true,
      table_data: [],
      columns: columns,
      sortKey: "user_id", // sort key awal
      sortOrders: sortOrders,
      currentTablePage: "",

      // parsing data ke table data
      tableData: {
        draw: 0,
        length: 10,
        search: "",
        column: 0,
        dir: "asc",
      },

      // config untuk paginasi
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
    };
  },
  created() {
    this.searchDatatable = debounce(() => {
      this.getDataTable();
      // call fetch API to get results
    }, 500);
  },
  mounted() {
    let self = this;
    self.cekAksesMenu();
    self.getDataTable();
  },
  methods: {
    cekAksesMenu() {
      let self = this;
      var config_axios = {
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "auth/check-access-menu",
        params: {
          role_id: self.sessionRoleId,
          link_name: self.namePathUrl,
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };
      axios(config_axios)
        .then((response) => {
          let response_data_fix = response.data.data.status_access;
          if (response.data.meta.code == 200) {
            if (response_data_fix == false) {
              Swal.fire({
                icon: "warning",
                title: "Oppss",
                text: "Mohon maaf anda tidak diberikan akses pada halaman ini.",
                timer: 2000,
                timerProgressBar: true,
                showConfirmButton: false,
              }).then((result) => {
                /* Read more about handling dismissals below */
                if (result.dismiss === Swal.DismissReason.timer) {
                  self.$router.push({ name: "dashboard" });
                }
              });
            }
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data_fix.data.message,
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    getDataTable(
      url = process.env.VUE_APP_BACKEND_URL_VERSION +
        "transactions/rekap/instruktur"
    ) {
      let self = this;
      self.loadingTable = true;
      self.tableData.draw++;

      var config = {
        method: "get",
        url: url,
        params: self.tableData,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then((response) => {
          let response_data = response.data;
          let response_data_fix = response_data.data[0];
          if (response_data.meta.code == 200) {
            if (self.tableData.draw == response_data_fix.draw) {
              self.table_data = response_data_fix.list_data.data;
              self.configPagination(response_data_fix.list_data);
              self.currentTablePage = response_data_fix.list_data.current_page;
            }
            self.loadingTable = false;
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data_fix.data.message,
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    configPagination(data) {
      let self = this;
      self.pagination.lastPage = data.last_page;
      self.pagination.currentPage = data.current_page;
      self.pagination.total = data.total;
      self.pagination.lastPageUrl = data.last_page_url;
      self.pagination.nextPageUrl = data.next_page_url;
      self.pagination.prevPageUrl = data.prev_page_url;
      self.pagination.from = data.from;
      self.pagination.to = data.to;
      self.pagination.links = data.links;
    },
    sortBy(key) {
      let self = this;
      self.sortKey = key;
      self.sortOrders[key] = self.sortOrders[key] * -1;
      self.tableData.column = self.getIndex(self.columns, "name", key);
      self.tableData.dir = self.sortOrders[key] === 1 ? "asc" : "desc";
      self.getDataTable();
    },
    getIndex(array, key, value) {
      return array.findIndex((i) => i[key] == value);
    },
    toPage: function (str) {
      let self = this;
      self.getDataTable(str);
    },
    dataPembelajaranDetail(user_id) {
      let self = this;
      self.idData = user_id;
      self.showDetail = false;
      self.$nextTick(() => {
        self.showDetail = true;
      });
    },
    exportDataExcel() {
      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading Ekspor Data ...",
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      var config = {
        method: "get",
        responseType: "arraybuffer",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "transactions/rekap/export-instruktur",
        headers: {
          Authorization: "Bearer " + localStorage.access_token,
          Accept: "application/vnd.ms-excel",
        },
      };

      axios(config).then(function (response) {
        if (response.data.meta?.code == 500) {
          Swal.close();
          Swal.fire({
            icon: "warning",
            title: "Oops...",
            text: "Error, mohon coba lagi.",
          });
        } else {
          Swal.close();
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: "application/csv" })
          );
          // console.log(url);
          const link = document.createElement("a");
          link.href = url;
          const timestamp = moment().format("YYYYMMDD_HHmmss");
          link.setAttribute(
            "download",
            "export-rekap-instruktur-" + timestamp + ".xlsx"
          );
          document.body.appendChild(link);
          link.click();
        }
      });
    },
  },
};
</script>
<style>
th {
  border-color: grey !important;
}

td {
  border-color: grey !important;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-6">
                <div class="card-title">Semua Rekap Instruktur</div>
              </div>
              <div class="col-6">
                <div class="text-end">
                  <button
                    type="button"
                    class="btn btn-info btn-sm"
                    @click="exportDataExcel()"
                  >
                    <i class="fa fa-file-excel"></i> Export Rekap
                  </button>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <hr />
            </div>
            <div class="col-md-12 mb-2">
              <div class="row">
                <div class="col-md-4">
                  <table>
                    <tr>
                      <td>Show</td>
                      <td>
                        <select
                          class="form-control form-control-sm"
                          id="showpaginatetable"
                          style="width: 100%"
                          v-model="tableData.length"
                          @change="getDataTable()"
                        >
                          <option value="10" selected>10</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                          <option value="200">200</option>
                          <option value="500">500</option>
                        </select>
                      </td>
                      <td>Entries</td>
                    </tr>
                  </table>
                </div>
                <div class="col-md-5">&nbsp;</div>
                <div class="col-md-3">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    id="searchTable"
                    placeholder="Cari Data ..."
                    v-model="tableData.search"
                    @input="searchDatatable"
                  />
                </div>
              </div>
            </div>
            <datatable
              :columns="columns"
              :sortKey="sortKey"
              :sortOrders="sortOrders"
              @sort="sortBy"
            >
              <tbody>
                <tr v-if="loadingTable">
                  <td colspan="8">
                    <i class="fas fa-spinner fa-spin"></i> Loading...
                  </td>
                </tr>
                <tr v-else-if="table_data == ''">
                  <td class="text-center" colspan="8">Data Tidak Tersedia</td>
                </tr>
                <tr
                  v-else
                  v-for="(row_data, key_data) in table_data"
                  :key="key_data"
                >
                  <td class="text-center">
                    <div v-if="key_data + 1 == 10">
                      {{ currentTablePage }}0.
                    </div>
                    <div v-else>
                      {{ currentTablePage - 1 != 0 ? currentTablePage - 1 : ""
                      }}{{ key_data + 1 }}.
                    </div>
                  </td>
                  <td>
                    {{ row_data.username }}
                  </td>
                  <td>
                    {{ row_data.name }}
                  </td>
                  <td>
                    {{ row_data.unit_name }}
                  </td>
                  <td>
                    {{ row_data.jabatan_name }}
                  </td>
                  <td>
                    {{ row_data.email }}
                  </td>
                  <td>
                    {{ row_data.mobile_phone }}
                  </td>
                  <td class="text-center">
                    <div v-if="row_data.total_pembelajaran_selesai == 0">
                      <div class="d-grid gap-2">
                        <button
                          type="button"
                          class="btn btn-danger btn-sm btn-block"
                        >
                          0 Pembelajaran
                        </button>
                      </div>
                    </div>
                    <div v-else>
                      <div class="d-grid gap-2">
                        <div class="d-grid gap-2">
                          <button
                            type="button"
                            class="btn btn-success btn-sm btn-block"
                            @click="dataPembelajaranDetail(row_data.user_id)"
                          >
                            {{ row_data.total_pembelajaran_selesai }}
                            Pembelajaran
                          </button>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </datatable>
            <pagination :pagination="pagination" @to-page="toPage"></pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- Popup Form Detail Rekap Instruktur -->
    <b-modal
      v-model="showDetail"
      title="Detail Rekap Instruktur"
      title-class="text-black font-18"
      body-class="p-3"
      size="xl"
      hide-footer
    >
      <detail-rekap-instruktur
        v-if="showDetail"
        :userId="idData"
      ></detail-rekap-instruktur>
    </b-modal>
  </Layout>
</template>
